import { DependentEntityInfo } from "@common/types";

export class FormsPageReadModel
{
   AlternativesListId: number;
   Forms: FormReadModel[];
}

export class FormReadModel
{
    Id: number;
    Name: string;
    Description: string;
    Created: string;
    Modified: string;
    Blurb: string;
    BlurbVisible: boolean;
    NameReadonly: boolean;
    DescriptionReadonly: boolean;
    IncludeStatus: boolean;
    IncludeDescription: boolean;
    StatusReadonly: boolean;
    Fields: FormFieldReadModel[];
}

export class FormFieldReadModel 
{
    AttributeId: number;
    OverrideName: string;
    OverrideDescription: string;
    OverrideSection: string;
    OverrideOrderValue: number | null;
    OverrideRequired: boolean | null;
    Readonly: boolean;
}

export class FormDesignerReadModel 
{
    AlternativesListId: number;
    AlternativeLabel: string;

    Id: number;
    Name: string;
    Description: string;
    Blurb: string;
    NameReadonly: boolean;
    DescriptionReadonly: boolean;
    IncludeStatus: boolean;
    IncludeDescription: boolean;
    StatusReadonly: boolean;

    Attributes: FormDesignerAttributeReadModel[];
}

export class FormDesignerAttributeReadModel 
{
    Id: number = null;

    AttributeName: string = null;
    AttributeDescription: string = null;
    AttributeSection: string = null;

    IsIncluded: boolean = false;
    IsFieldRequired: boolean = false;
    IsFieldReadonly: boolean = false;
    IsHovering: boolean = false;

    FieldName: string = null;
    FieldDescription: string = null;
    FieldSection: string = null;
    FieldOrderValue: number = null;
}

export class FormDefDependenciesReadModel
{
    WorkspaceId: number;
    ProjectId: number;
    AlternativesListId: number;

    Id: number;
    Name: string;
    HasDependants: boolean;
    Count: number;
    Notifications: DependentEntityInfo[];
    Reports: DependentEntityInfo[];
    RequestPages: DependentEntityInfo[];
}


